module.exports = __webpack_public_path__ + "static/media/music-app.429c3e20.PNG";